import { Injectable } from '@angular/core'
import { CommonService } from '../../shared/services/common.service'
@Injectable({
  providedIn: 'root',
})
export class ContactformService {
  constructor(public commonService: CommonService) {}

  getContactForm() {
    const urlParams = ['users', 'anonymous', 'contactUsAnonymousUser']
    let apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.getData(apiUrl)
  }

  postContact(postData) {
    const urlParams = ['users', 'anonymous', 'contactUsAnonymousUser']
    let apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.postData(apiUrl, postData)
  }
}
